import { Moment } from 'moment';

export default (left: Moment, right: Moment) : boolean => {
  if (left !== null && right !== null) {
    return left.isSame(right)
  }
  return left == right
}
